<template>
    <div>
        <sensor-overview class="sensoroverview" :sensor="sensor" v-for="sensor in sensors"
                         :key="sensor.device"></sensor-overview>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import SensorOverview from './SensorOverview'
import sortBy from 'lodash/sortBy'
const {mapActions, mapState} = createNamespacedHelpers('sensor')

export default {
  name: 'SensorList',
  components: {SensorOverview},
  computed: mapState({
    sensors: state => {
      return sortBy(state.sensors, [s => !s.hasConnection, s => s.device])
    }
  }),
  methods:{
    ...mapActions([
      'getSensors',
      'getSensorValues'
    ])
  },
  async created () {
    await this.getSensors()
    this.$store.commit('core/setViewLoading', false)
    this.updater = setInterval(() => {
      this.getSensorValues()
    }, 9000)
  },
  destroyed () {
    clearInterval(this.updater)
  }
}
</script>

<style lang="scss">
    .sensoroverview {
        margin-bottom: 24px;
    }
</style>
